const locale = {
    message: {
        services: "Servicios",
        welcome: "Bienvenido",
        email: "Email",
        password: "Password",
        login: "Iniciar sesión",
        logout: "Cerrar sesión",
        check_credencials: "Verifica tus credenciales de acceso",
        list_reservations: "Lista de servicios",
        list_completed_reservations: "Lista de servicios completados",
        contact: "Contacto",
        evidence: "Evidencias",
        comment: "Comentario",
        type_a_comment: "Escribe un comentario",
        evidence_images: "Imagenes de evidencia",
        take_a_photo: "Tomar fotos",
        confirm: "Confirmar",
        cancel: "Cancelar",
        close: "Cerrar",
        service_shuttle: "Servicio de traslado",
        contact_us: "Contáctanos",
        chat: "Chat",
        phone: 'Teléfono',
        loading_more_information: "Cargando más información...",
        completed_reservations: "Reservaciones completadas",
        home: "Inicio",
        service_sheet: "Hoja de servicio",
        welcome_sign: "Mostrar cartel de bienvenida",
        loading: "Cargando...",
        name: "Nombre",
        business_phone: "Teléfono empresarial",
        personal_phone: "Teléfono personal",
        model: "Modelo",
        manufacturer: "Fabricante",
        car_registration: "Matrícula",
        vehicle_updated: "Se ha actualizado el vehículo asignado",
        driver_updated: "Se ha actualizado el conductor asignado",
        error_update_reservation: "Hubo un error al actualizar la reserva",
        search_vehicle: "Buscar vehículo",
        search_driver: "Buscar conductor",
        change_driver: "Cambiar conductor",
        change_vehicle: "Cambiar vehículo",
        driver_information: "Información del conductor",
        vehicle_information: "Información del vehículo",
        precise_location_permission_title: "Permisos de localización precisa",
        precise_location_permission_description: "Requerimos obtener su ubicación precisa para realizar el seguimiento del vehículo durante el servicio de traslado incluso cuando la aplicación esté en segundo plano",
        vehicle: "vehículo",
        save: "Guardar",
        id: "Número de reservación",
        tracing_number: "Número de seguimiento",
        today_reservations: "Hoy",
        next_days: "Días posteriores"
    },
    status: {
        "none": "Sin asignar",
        "waiting-on-meeting-point": "Esperando al cliente en punto de encuentro",
        "on-way-to-meeting-point": "En camino al punto",
        "customer-on-board": "Cliente abordo",
        "no-show": "Cliente no se presento",
        "completed": "Viaje completado",
        "cancelled": "Cancelado",
    },
    reservation: {
        service_shuttle: "Servicio de traslado",
        service_by_hour: "Servicio por hora",
        service_tour: "Tour",
        reservation: "Reservación",
        status: "Estatus",
        time_service: "Hora de servicio",
        time_pickup: "Hora de recogida",
        passangers: "Pasajeros",
        id: "ID",
        flight_number: "Numero de vuelo",
        address_origin: "Direccion de origen",
        address_destination: "Direccion de destino",
        notes: "Nota especiales",
        addons: "Extras",
        change_status: "Cambiar estado a",
    },
    app_settings: {
        update_available: "Actualización disponible",
        update_last_version: "Hay una actualización disponible, por favor actualice a la última versión",
        update: "Actualizar",
        cancel: "Cancelar"
    }
}

export default locale;